import React from 'react';

export function OmSVG({ size = 120, color = '#C9902A', className = '' }) {
  return (
    <svg
      viewBox="0 0 200 200"
      width={size}
      height={size}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      {/* Om symbol drawn as path */}
      <path
        d="M100 30
           C75 30, 55 48, 55 72
           C55 88, 63 101, 76 109
           C63 112, 55 122, 55 134
           C55 150, 68 162, 84 162
           C92 162, 99 158, 104 152
           C104 152, 106 168, 122 168
           C134 168, 144 158, 144 146
           C144 132, 135 122, 122 120
           C135 113, 144 100, 144 85
           C144 55, 124 30, 100 30Z"
        fill={color}
        opacity="0.9"
      />
      {/* The curved tail */}
      <path
        d="M122 120 C138 115, 155 102, 155 82 C155 68, 148 56, 138 50"
        stroke={color}
        strokeWidth="6"
        strokeLinecap="round"
        fill="none"
        opacity="0.7"
      />
      {/* The dot and arc above */}
      <circle cx="130" cy="38" r="7" fill={color} opacity="0.9" />
      <path
        d="M100 20 C118 16, 135 22, 142 35"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
        opacity="0.8"
      />
    </svg>
  );
}

export function OmGlyph({ size = 80, color = '#F5C842', className = '' }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className}>
      <text
        x="50"
        y="72"
        textAnchor="middle"
        fontSize="75"
        fill={color}
        fontFamily="serif"
        opacity="0.95"
      >
        ॐ
      </text>
    </svg>
  );
}

export function LotusFlower({ size = 200, className = '' }) {
  const petalColor = '#E8A0BF';
  const centerColor = '#F5C842';
  const petalCount = 8;

  const petals = Array.from({ length: petalCount }, (_, i) => {
    const angle = (i * 360) / petalCount;
    return (
      <ellipse
        key={i}
        cx="100"
        cy="60"
        rx="18"
        ry="40"
        fill={petalColor}
        opacity="0.85"
        transform={`rotate(${angle}, 100, 100)`}
      />
    );
  });

  const innerPetals = Array.from({ length: petalCount }, (_, i) => {
    const angle = (i * 360) / petalCount + 22.5;
    return (
      <ellipse
        key={i}
        cx="100"
        cy="72"
        rx="12"
        ry="26"
        fill="#F4C2D8"
        opacity="0.9"
        transform={`rotate(${angle}, 100, 100)`}
      />
    );
  });

  return (
    <svg viewBox="0 0 200 200" width={size} height={size} className={className}>
      <g>{petals}</g>
      <g>{innerPetals}</g>
      <circle cx="100" cy="100" r="22" fill={centerColor} opacity="0.95" />
      <circle cx="100" cy="100" r="12" fill="#FF6B00" opacity="0.9" />
      <circle cx="100" cy="100" r="5" fill="#FFF8EE" opacity="0.95" />
    </svg>
  );
}

export function Mandala({ size = 300, className = '', opacity = 0.15 }) {
  const rings = [24, 16, 12, 8];
  const radii = [130, 100, 70, 45];
  const dotR = [3, 3.5, 4, 5];

  return (
    <svg viewBox="0 0 300 300" width={size} height={size} className={className} opacity={opacity}>
      {/* Outer decorative rings */}
      {[140, 110, 80, 50, 25].map((r, i) => (
        <circle key={i} cx="150" cy="150" r={r} stroke="#C9902A" strokeWidth={i === 0 ? 1.5 : 0.8} fill="none" />
      ))}
      {/* Dot rings */}
      {rings.map((count, ri) =>
        Array.from({ length: count }, (_, i) => {
          const angle = (i * 2 * Math.PI) / count;
          const x = 150 + radii[ri] * Math.cos(angle);
          const y = 150 + radii[ri] * Math.sin(angle);
          return <circle key={`${ri}-${i}`} cx={x} cy={y} r={dotR[ri]} fill="#C9902A" />;
        })
      )}
      {/* Petal shapes */}
      {Array.from({ length: 16 }, (_, i) => {
        const angle = (i * 360) / 16;
        return (
          <ellipse
            key={i}
            cx="150"
            cy="95"
            rx="6"
            ry="18"
            fill="#FF6B00"
            opacity="0.6"
            transform={`rotate(${angle}, 150, 150)`}
          />
        );
      })}
      {/* Center */}
      <circle cx="150" cy="150" r="12" fill="#C9902A" />
      <circle cx="150" cy="150" r="6" fill="#F5C842" />
      {/* Star lines */}
      {Array.from({ length: 12 }, (_, i) => {
        const angle = (i * 360) / 12;
        const rad = (angle * Math.PI) / 180;
        return (
          <line
            key={i}
            x1="150"
            y1="150"
            x2={150 + 130 * Math.cos(rad)}
            y2={150 + 130 * Math.sin(rad)}
            stroke="#C9902A"
            strokeWidth="0.5"
            opacity="0.5"
          />
        );
      })}
    </svg>
  );
}

export function DiamondDivider({ color = '#C9902A' }) {
  return (
    <svg viewBox="0 0 300 20" width="300" height="20" style={{ display: 'block', margin: '0 auto' }}>
      <line x1="0" y1="10" x2="120" y2="10" stroke={color} strokeWidth="0.8" opacity="0.6" />
      <polygon points="140,2 150,10 140,18 130,10" fill={color} opacity="0.8" />
      <polygon points="160,5 168,10 160,15 152,10" fill={color} opacity="0.6" />
      <polygon points="118,5 126,10 118,15 110,10" fill={color} opacity="0.6" />
      <line x1="180" y1="10" x2="300" y2="10" stroke={color} strokeWidth="0.8" opacity="0.6" />
    </svg>
  );
}

export function FlameSVG({ size = 60, className = '' }) {
  return (
    <svg viewBox="0 0 60 80" width={size} height={(size * 80) / 60} className={className}>
      <defs>
        <radialGradient id="flameGrad" cx="50%" cy="80%" r="60%">
          <stop offset="0%" stopColor="#FFF3A0" />
          <stop offset="40%" stopColor="#FF6B00" />
          <stop offset="100%" stopColor="#8B1A1A" stopOpacity="0" />
        </radialGradient>
      </defs>
      <path
        d="M30 5 C30 5, 50 25, 50 45 C50 60, 41 72, 30 72 C19 72, 10 60, 10 45 C10 25, 30 5, 30 5Z"
        fill="url(#flameGrad)"
      />
      <path
        d="M30 25 C30 25, 40 38, 40 50 C40 58, 35 65, 30 65 C25 65, 20 58, 20 50 C20 38, 30 25, 30 25Z"
        fill="#FFF3A0"
        opacity="0.7"
      />
    </svg>
  );
}

export function SwamiKalasam({ size = 50, className = '' }) {
  return (
    <svg viewBox="0 0 50 70" width={size} height={(size * 70) / 50} className={className}>
      {/* Kalasam / pot shape */}
      <ellipse cx="25" cy="55" rx="18" ry="10" fill="#C9902A" opacity="0.9" />
      <path d="M10 55 Q8 35, 15 28 Q20 22, 25 22 Q30 22, 35 28 Q42 35, 40 55Z" fill="#C9902A" opacity="0.85" />
      <ellipse cx="25" cy="27" rx="10" ry="5" fill="#F5C842" opacity="0.9" />
      {/* Coconut leaves at top */}
      <path d="M25 22 Q20 10, 10 8" stroke="#2D5016" strokeWidth="2" fill="none" />
      <path d="M25 22 Q30 10, 40 8" stroke="#2D5016" strokeWidth="2" fill="none" />
      <path d="M25 22 Q22 8, 22 2" stroke="#2D5016" strokeWidth="1.5" fill="none" />
      {/* Mango leaves */}
      <ellipse cx="10" cy="8" rx="5" ry="3" fill="#2D5016" transform="rotate(-30,10,8)" />
      <ellipse cx="40" cy="8" rx="5" ry="3" fill="#2D5016" transform="rotate(30,40,8)" />
      {/* Decoration on pot */}
      <path d="M13 42 Q25 38, 37 42" stroke="#F5C842" strokeWidth="1.5" fill="none" opacity="0.7" />
      <circle cx="25" cy="48" r="4" fill="#FF6B00" opacity="0.8" />
    </svg>
  );
}

export function RangoliCorner({ size = 120, className = '' }) {
  return (
    <svg viewBox="0 0 120 120" width={size} height={size} className={className}>
      <path d="M0 0 L60 0 L0 60Z" fill="#C9902A" opacity="0.08" />
      {/* Dots pattern */}
      {[0,1,2,3,4].map(row =>
        Array.from({ length: 5 - row }, (_, col) => (
          <circle
            key={`${row}-${col}`}
            cx={10 + col * 20 + row * 10}
            cy={10 + row * 20}
            r="2.5"
            fill="#C9902A"
            opacity={0.4 - row * 0.06}
          />
        ))
      )}
      {/* Curved decorative lines */}
      <path d="M0 80 Q40 40, 80 0" stroke="#FF6B00" strokeWidth="0.8" fill="none" opacity="0.3" />
      <path d="M0 100 Q50 50, 100 0" stroke="#C9902A" strokeWidth="0.5" fill="none" opacity="0.2" />
      {/* Small petals at corner */}
      <ellipse cx="8" cy="8" rx="5" ry="10" fill="#FF6B00" opacity="0.2" transform="rotate(-45,8,8)" />
    </svg>
  );
}

export function SwastikaSVG({ size = 40, color = '#C9902A', className = '' }) {
  return (
    <svg viewBox="0 0 40 40" width={size} height={size} className={className} opacity="0.6">
      <path
        d="M20 5 L20 35 M5 20 L35 20
           M20 5 L28 5 L28 12 M20 35 L12 35 L12 28
           M5 20 L5 12 L12 12 M35 20 L35 28 L28 28"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
}
